function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default (function (theme, _ref) {
  var getColor = _ref.getColor;
  return {
    getCSS: function getCSS(_ref2) {
      var targetElement = _ref2.targetElement,
          color = _ref2.color,
          isPlaceholder = _ref2.isPlaceholder,
          isHighlighted = _ref2.isHighlighted,
          __internal__focus = _ref2.__internal__focus;

      switch (targetElement) {
        case "container":
          {
            return {
              position: "relative"
            };
          }

        case "button":
          {
            return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
              display: "flex",
              alignItems: "center",
              boxSizing: "border-box",
              padding: theme.space[4],
              width: "100%",
              color: theme.colors.black,
              backgroundColor: getColor(color),
              textAlign: "left",
              margin: 0,
              border: 0,
              borderRadius: theme.radii[0],
              outline: 0
            }, theme.focusStyles.focusVisible), isPlaceholder && {
              padding: "".concat(theme.space[2], " ").concat(theme.space[4])
            }), __internal__focus && theme.focusStyles.__keyboardFocus), {}, {
              // See: https://stackoverflow.com/a/199319/247243
              "::-moz-focus-inner": {
                border: 0
              }
            });
          }

        case "buttonContent":
          {
            return {
              display: "flex",
              alignItems: "center",
              flexGrow: 1
            };
          }

        case "buttonChevron":
          {
            return {
              display: "flex",
              transformOrigin: "50% 50%",
              transition: "transform .25s ease"
            };
          }

        case "options":
          {
            return {
              position: "absolute",
              width: "100%",
              margin: 0,
              padding: 0,
              backgroundColor: theme.colors.white,
              boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.3)",
              overflowY: "auto",
              zIndex: theme.zIndices.dropdown,
              ":focus": {
                outline: 0
              }
            };
          }

        case "option":
          {
            return _objectSpread({
              listStyleType: "none",
              padding: theme.space[4],
              borderTop: "".concat(theme.borderWidths[0], " solid ").concat(theme.colors.grey.t10),
              cursor: "default"
            }, isHighlighted && {
              backgroundColor: theme.colors.secondary.lightBlue.t25
            });
          }

        default:
          {
            return null;
          }
      }
    }
  };
});